import { cloneDeep, get, isArray, set } from 'lodash';
import { ANTRAGS_STATUS, KOSTEN_ARTEN, SACHKOSTEN_DEFAULT_AMOUNT } from '../../../../../lib/constants/constant';
import { getFieldNamefromDataPath, getIDFromResponseOption } from '../../../../../utils/helper';

// import Schemas
import { getHalbJahrDetail } from '../../../../../lib/api/antrag';
import AntragSchema from '../../../../../lib/paths/antrag_FULL_Paths.json';
// import FoerderProgrammSchema from '../../../../../lib/paths/foerderprogramm_FULL_Paths.json';
import KostenPositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
import { find } from 'lodash';
const P = AntragSchema.attributes;
// const FP_P = FoerderProgrammSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const executeAntragsFormulas = (application: any, allFoerderProgramm: any[], schulJahrDetails: any, allSparte: any) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];

	const calculatedPersonalKosten = calculatePersonalKosten(appCopy, allFoerderProgramm, allSparte);
	if (isArray(calculatedPersonalKosten)) {
		for (let ele of calculatedPersonalKosten) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedPersonalKosten);

	const calculatedSachKosten = calculateSachKosten(appCopy, schulJahrDetails);
	if (isArray(calculatedSachKosten)) {
		for (let ele of calculatedSachKosten) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedSachKosten);

	const calculatedBeantragteFoerderSumme = calculateBeantragteFoerderSumme(appCopy);
	if (isArray(calculatedBeantragteFoerderSumme)) {
		for (let ele of calculatedBeantragteFoerderSumme) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedBeantragteFoerderSumme);

	const ubernomenBeantragteDatenZuBewilligung = uebernehmenBeantragteZuBewilligte(appCopy);
	if(get(application, P.Status_Status.path) === ANTRAGS_STATUS.inBearbeitung){
		if (isArray(ubernomenBeantragteDatenZuBewilligung)) {
			for (let ele of ubernomenBeantragteDatenZuBewilligung) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		result.push(...ubernomenBeantragteDatenZuBewilligung);
	}
	return result;
};

function calculatePersonalKosten(application: any, allFoerderProgramm: any, allSparte: any) {
	let result: any[] = [];
	const allkostenPostion = get(application, P.Antrag_Kostenpositions.path, []);
	result.push({
		path: `${P.Antrag_Kostenpositions.path}`,
		value: transformPersonalKosten(allkostenPostion, allFoerderProgramm, allSparte),
	});
	return result;
}
function calculateSachKosten(application: any, schulJahrDetails: any) {
	let result: any[] = [];
	const antragHalbJahr = get(application, P.Zusammenfassung_Ueberblick_Halbjahr.path, '');
	const allkostenPostion = get(application, P.Antrag_Kostenpositions.path, []);
	result.push({
		path: `${P.Antrag_Kostenpositions.path}`,
		value: transformSachKosten(allkostenPostion, antragHalbJahr, schulJahrDetails),
	});
	return result;
}
function calculateBeantragteFoerderSumme(application: any) {
	let result: any[] = [];
	const allKostenPositions = get(application, P.Antrag_Kostenpositions.path, []);

	const summe = allKostenPositions.reduce(
		(acc: any, ele: any) => acc + parseFloat(get(ele, KP_P.Beantragte_Foerderung_beantragte_Foerderung.path, '0')),
		0
	);

	result.push({
		path: P.Zusammenfassung_Ueberblick_beantragte_Foerdersumme.path,
		value: !isNaN(summe) ? summe : 0,
	});
	return result;
}
function uebernehmenBeantragteZuBewilligte(application: any) {
	let result: any[] = [];
	const allKostenPosition = get(application, P.Antrag_Kostenpositions.path, []);
	result.push({
		path: `${P.Antrag_Kostenpositions.path}`,
		value: bewilligteDatenUebernahme(allKostenPosition),
	});
	return result;
}

/**
 * *************************************************************************************************************************************************************
 * ************************************************************** HELPER FUNCTIONS *****************************************************************************
 * *************************************************************************************************************************************************************
 */
function transformPersonalKosten(allKostenPosition: any[], _allFoerderProgramm: any, allSparte: any) {
	const programmMap = new Map<string, any>();

	for (const item of allKostenPosition) {
		if (get(item, KP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Personalkosten && get(item, KP_P.Allgemein_Gruppierung_ID.path)) {
			const gruppierungID = get(item, KP_P.Allgemein_Gruppierung_ID.path);
			const foerderprogramm = get(item, KP_P.Allgemein_Foerderprogramm.path);

			if (!programmMap.has(gruppierungID) && foerderprogramm) {
				programmMap.set(gruppierungID, foerderprogramm);
			}
		}
	}

	const allPostionToReturn = allKostenPosition.map((ele: any) => {
		if (get(ele, KP_P.Allgemein_Gruppierung_ID.path) && get(ele, KP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Personalkosten) {
			const gruppierungID = get(ele, KP_P.Allgemein_Gruppierung_ID.path);
			const ersterProgramm = programmMap.get(gruppierungID);
			const klasse = parseFloat(get(ele, KP_P.Beantragte_Foerderung_Klassen.path, '0')) || 0;
			const stundeProWoche = parseFloat(get(ele, KP_P.Beantragte_Foerderung_Ustd_Woche.path, '0') ) || 0;
			const uwo = parseFloat(get(ele, KP_P.Beantragte_Foerderung_Uwo.path, '0')) || 0;
			const honorarSatz = parseFloat(get(ele, KP_P.Beantragte_Foerderung_Honorarsatz.path, '0')) || 0;			
			// || getHonorarSatzAusFoerderProgramm(getIDFromResponseOption(ersterProgramm), allFoerderProgramm);
			
			const selectedSparteID = getIDFromResponseOption(get(ele, KP_P.Allgemein_Sparte.path));
			const selectedSparte = find(allSparte, (sp: any) => get(sp, 'id') === selectedSparteID);
			const sparteSachkostenErlaubt = get(selectedSparte, 'attributes.Allgemein_Sachkosten_Erlaubt', false);
			
			const beantragtePersonalkosten = stundeProWoche * uwo * honorarSatz;
			const sachkosten = sparteSachkostenErlaubt ? klasse * SACHKOSTEN_DEFAULT_AMOUNT : 0;
			const beantragteFoerderung = beantragtePersonalkosten + sachkosten;

			const returData = {
				...ele,
				attributes: {
					...get(ele, 'attributes', {}),
					[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Honorarsatz.path)]: !isNaN(honorarSatz) ? honorarSatz : 0,
					[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Sachkosten.path)]: !isNaN(sachkosten) ? sachkosten : 0,
					[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_beantragte_Personalkosten.path)]: !isNaN(beantragtePersonalkosten) ? beantragtePersonalkosten : 0,
					[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_beantragte_Foerderung.path)]:
						!isNaN(beantragteFoerderung) ? beantragteFoerderung : 0,
					[getFieldNamefromDataPath(KP_P.Allgemein_Foerderprogramm.path)]: getIDFromResponseOption(ersterProgramm), // Förderprogramm ersetzen
				},
			};
			return returData;
		} else {
			return ele;
		}
	});
	return allPostionToReturn;
}
function transformSachKosten(allKostenPosition: any[], antragHalbJahr: string, schulJahrDetails: any) {
	const programmMap = new Map<string, any>();

	const halbJahrDetails = getHalbJahrDetail(schulJahrDetails, antragHalbJahr);

	for (const item of allKostenPosition) {
		if (get(item, KP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Sachkosten && get(item, KP_P.Allgemein_Gruppierung_ID.path)) {
			const gruppierungID = get(item, KP_P.Allgemein_Gruppierung_ID.path);
			const foerderprogramm = get(item, KP_P.Allgemein_Foerderprogramm.path);

			if (!programmMap.has(gruppierungID) && foerderprogramm) {
				programmMap.set(gruppierungID, foerderprogramm);
			}
		}
	}

	return allKostenPosition.map((ele: any) => {
		if (get(ele, KP_P.Allgemein_Gruppierung_ID.path) && get(ele, KP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Sachkosten) {
			const gruppierungID = get(ele, KP_P.Allgemein_Gruppierung_ID.path);
			const ersterProgramm = programmMap.get(gruppierungID);

			if (ersterProgramm) {
				// const honorarSatz = parseFloat(get(ele, KP_P.Beantragte_Foerderung_Honorarsatz.path, '0')) || 0;
				const beantragteFoerderung =
					parseFloat(get(ele, KP_P.Beantragte_Foerderung_beantragte_Foerderung.path, '0')) ||
					parseFloat(get(halbJahrDetails, 'sachkosten', '0'));

				return {
					...ele,
					attributes: {
						...get(ele, 'attributes', {}),
						[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_beantragte_Foerderung.path)]:
							!isNaN(beantragteFoerderung) ? beantragteFoerderung : 0,
						[getFieldNamefromDataPath(KP_P.Allgemein_Foerderprogramm.path)]: getIDFromResponseOption(ersterProgramm),
					},
				};
			}
		}
		return ele;
	});
}
function bewilligteDatenUebernahme(allkostenPostion: any[]) {
	return allkostenPostion.map((ele: any) => {
		return {
			...ele,
			attributes: {
				...get(ele, 'attributes', {}),
				// Bewilligte zahlen vorbelegen
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Klassen.path)]: getNumberValue(get(ele, KP_P.Beantragte_Foerderung_Klassen.path)),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Ustd_Woche.path)]: getNumberValue(
					get(ele, KP_P.Beantragte_Foerderung_Ustd_Woche.path)
				),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Uwo.path)]: getNumberValue(get(ele, KP_P.Beantragte_Foerderung_Uwo.path)),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Anstellung.path)]: get(ele, KP_P.Beantragte_Foerderung_Anstellung.path, null),

				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Honorarsatz.path)]: getNumberValue(
					get(ele, KP_P.Beantragte_Foerderung_Honorarsatz.path)
				),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Sachkosten.path)]: getNumberValue(
					get(ele, KP_P.Beantragte_Foerderung_Sachkosten.path)
				),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_beantragte_Personalkosten.path)]: getNumberValue(
					get(ele, KP_P.Beantragte_Foerderung_beantragte_Personalkosten.path)
				),
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_bewilligte_Foerderung.path)]: getNumberValue(
					get(ele, KP_P.Beantragte_Foerderung_beantragte_Foerderung.path)
				),
			},
		};
	});
}

// function getHonorarSatzAusFoerderProgramm(programmId: number, allFoerderProgramm: any): number {
// 	const selectedProgramm = allFoerderProgramm.find((ele: any) => get(ele, 'id') === programmId);

// 	return parseFloat(get(selectedProgramm, FP_P.Vorgaben_Honorarsatz.path, '0'));
// }

function getNumberValue(value: number) {
	return !isNaN(value) ? value : 0;
}
